import _ from 'underscore';
import $ from 'jquery';

// focusable also means clickable.
function isFocusable(ele) {
  return $(ele).is('a[href], area[href], button, details, input, iframe, select, textarea, [tabindex], [onclick], [data-inline=1], .grid-editable-cell');
}

// For vNext
export const assistedSelectionPlugin = (definePlugin) => definePlugin('assisted-selection', ['gridView'], (gridView) => {
  const assistedSelection = {
    name: 'assisted-selection',
    handler(state) {
      const selection = gridView.get('selection');

      if (selection === false || (_.isObject(selection) && selection.enabled === false)) {
        return state;
      }

      const events = {
        'click tbody tr[data-key]': (e) => {
          const parents = $(e.target).parentsUntil('tr');
          const focusableElems = _.find(_.union(_.toArray(parents), [e.target]), (ele) => {
            return isFocusable(ele);
          });

          if (focusableElems) {
            return;
          }

          setTimeout(() => {
            const sel = window.getSelection();

            if (sel.isCollapsed) {
              const key = this.keyOfElement(e.target);

              if (!_.isNull(key)) {
                if (_.contains(gridView.selectedKeys(), key)) {
                  if (!selection.single) {
                    gridView.deselectRow(key);
                  }
                } else {
                  gridView.selectRow(key);
                }
              }
            }
          }, 100);
        },
      };

      _.defaults(events, state.events);

      return _.defaults({ events }, state);
    },
    defaults: {},
  };

  gridView.pipeContentProjections(assistedSelection);
});

// For non-vNext
export function applyAssistedSelection(grid) {
  $(grid.el).on('click tbody tr', (e) => {
    const parents = $(e.target).parentsUntil('tr');
    const focusableElems = _.find(_.union(parents, [e.target]), (ele) => {
      return isFocusable(ele);
    });

    if (focusableElems) {
      return;
    }

    const data = grid.layout.dataFor(e.target);

    if (data && data.model) {
      setTimeout(() => {
        const sel = window.getSelection();

        if (sel.isCollapsed) {
          const id = data.model[grid.projection.get('row.check.id')];
          const selection = grid.getSelection();

          if (_.contains(selection, id)) {
            grid.projection.set('row.check.list', _.without(selection, id));
          } else {
            grid.projection.set('row.check.list', _.union(selection, [id]));
          }
        }
        grid.trigger('change:row.check.list');
      }, 100);
    }

  });
}
